export const SERVICE_NAMES = Object.freeze({
  HOME: 'home',
  SYMPTOMS: 'symptoms',
  NOTIFICATIONS: 'notifications',
  MEDICATION_REMINDERS: 'medication-reminders',
  GOALS: 'goals',
  NUTRITION: 'nutrition',
  FILES: 'files',
  RESOURCES: 'resources',
  FLUID: 'fluid',
  APP_VERSION: 'app-version',
  AUTH: 'auth',
  ONBOARDING: 'onboarding',
  FIREBASE_PUSH: 'firebase-push',
  PATIENT_CREDENTIAL_AUTH: 'patient-credential-auth',
  BLOOD_TEST_RESULTS: 'blood-test-results',
  FOOD_GUIDE: 'food-guide',
});
